import apiServices from '../../ApiServices/request-handler';
import { requestHandler } from '../../utils/functions';
import { setCommonLoading } from '../slices/commonSlice';

export const generateGeneralOtp = (params, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.generateGeneralOtp,
        param_data: params,
        setLoading: setCommonLoading,
        isSuccessMessage: true,
        onDone: (data) => {
          onDone?.(data);
        },
      }),
    );
  };
};

export const verifyGeneralOtp = (data, onDone, onError) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.verifyGeneralOtp,
        param_data: data,
        setLoading: setCommonLoading,
        onDone,
        onError: (err) => onError(err?.data),
      }),
    );
  };
};

export const screenLog = (data) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.screenLog,
        param_data: data,
        onError: (err) => { }
      }),
    );
  };
};
